import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export default (props: SvgIconProps) => (
    <SvgIcon style={{ fontSize: 32 }} viewBox="0 0 32 32" {...props}>
        <path d="M15.87 20.5a5 5 0 1 0 0-9l-1.23-1.64a7 7 0 1 1 0 12.28zM13.95 13h-2.59l2.05 2H7a1 1 0 0 0 0 2h6.41l-2.05 2h2.59L17 16z" />
    </SvgIcon>
);
